import { apiUrlDomain } from "../../Utils/api.utils";

const TRADING_BOARD_DETAILS_DATA = [
    {
        "coverImg": `${apiUrlDomain}/Portals/0/Uploads/2/TEST3-892169757.png`,
        "symbol": "BRN_USA",
        "title": "test 123",
        "description": "test description",
        "general": {
            "last12MonthsEarnings": "$113,000",
            "threeYearAverageEarnings": "$130,000",
            "last12MonthsYield": "8.5%",
            "threeYearAverageYield": "10%",
            "dollarAge": "3.5 Y",
            "earningsMultiplePE": "11.8 X",
            "marketCap": "$1,329,412",
            "musicalComposition": "Public Performance, Mechanical",
            "soundRecording": "Streaming",
            "distributors": "ASCAP",
            "copyrights": "Not included",
            "symbolType": "Part of an album",
            "listingTerm": "Life",
            "royaltyDistributionDates": [
                "Mar 31, 1pm EST",
                "Nov 30, 1pm EST"
            ],
            "recordLabel": "Atlantic Records",
            "weeklyVolume": "45"
        },
        "news": [
            {
                "url": "https://rapradar.com/2023/03/31/album-dj-drama-im-really-like-that/",
                "title": "Album: DJ Drama ‘I’m Really Like That”",
                "source": "Rap Radar",
                "image_url": "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
                "date": "2023-03-31T04:04:00.000Z"
            },
            {
                "url": "https://www.billboard.com/lists/song-of-the-summer-2023-early-contenders/",
                "title": "Way-Too-Early Song of the Summer 2023 Contenders: The Front-Runners, Outside Shots & Question Marks",
                "source": "billboard",
                "image_url": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
                "date": "2023-03-30T19:55:01.000Z"
            },
            {
                "url": "https://allhiphop.com/news/tyler-the-creator-explains-why-being-a-rapper-is-awesome/",
                "title": "Tyler, The Creator Explains Why Being A Rapper Is “Awesome”",
                "source": "AllHipHop",
                "image_url": "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
                "date": "2023-03-30T12:33:30.000Z"
            },
            {
                "url": "https://www.okayplayer.com/music/tyler-the-creator-sorry-not-sorry.html",
                "title": "Watch Tyler, the Creator Channel All His Eras In the “Sorry Not Sorry” Music Video",
                "source": "Okayplayer",
                "image_url": "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
                "date": "2023-03-29T16:54:24.000Z"
            }
        ],
        "socialMediaStatistics": {
            "chartmetric": {
                "socialMedia": "Chartmetric",
                "icon": "social-media-logos/chartmetric.png",
                "statistics": {
                    "score": {
                        "title": "Score",
                        "value": 2000
                    }
                }
            },
            "tiktok": {
                "socialMedia": "TikTok",
                "icon": "social-media-logos/tiktok.png",
                "statistics": {
                    "posts": {
                        "title": "Posts",
                        "value": 5003604
                    },
                    "likes": {
                        "title": "Likes",
                        "value": 516146337
                    },
                    "views": {
                        "title": "Views",
                        "value": 4114763138
                    }
                }
            },
            "soundcloud": {
                "socialMedia": "Soundcloud",
                "icon": "social-media-logos/soundcloud.png",
                "statistics": {
                    "totalPlays": {
                        "title": "Total Plays",
                        "value": 161095443
                    }
                }
            },
            "pandora": {
                "socialMedia": "Pandora",
                "icon": "social-media-logos/pandora.png",
                "statistics": {
                    "streams": {
                        "title": "Streams",
                        "value": 257597084
                    },
                    "trackStations": {
                        "title": "Track Stations",
                        "value": 609002
                    }
                }
            },
            "spotify": {
                "socialMedia": "Spotify",
                "icon": "social-media-logos/spotify.png",
                "statistics": {
                    "popularity": {
                        "title": "Popularity",
                        "value": 83
                    },
                    "playlistReach": {
                        "title": "Playlist Reach",
                        "value": 69898713
                    },
                    "streams": {
                        "title": "Streams",
                        "value": 1634347508
                    }
                }
            },
            "youtube": {
                "socialMedia": "Youtube",
                "icon": "social-media-logos/youtube.png",
                "statistics": {
                    "views": {
                        "title": "Views",
                        "value": 1182153699
                    },
                    "likes": {
                        "title": "Likes",
                        "value": 15105438
                    }
                }
            },
            "genius": {
                "socialMedia": "Genius",
                "icon": "social-media-logos/genius.png",
                "statistics": {
                    "views": {
                        "title": "Views",
                        "value": 3398236
                    }
                }
            },
            "shazam": {
                "socialMedia": "Shazam",
                "icon": "social-media-logos/shazam.png",
                "statistics": {
                    "count": {
                        "title": "Count",
                        "value": 9581043
                    }
                }
            },
            "deezer": {
                "socialMedia": "Deezer",
                "icon": "social-media-logos/deezer.png",
                "statistics": {
                    "playlistReach": {
                        "title": "Playlist Reach",
                        "value": 563690
                    }
                }
            },
            "line": {
                "socialMedia": "Line",
                "icon": "social-media-logos/line.png",
                "statistics": {
                    "likes": {
                        "title": "Likes",
                        "value": 5731
                    },
                    "count": {
                        "title": "Listen Count",
                        "value": 631090
                    }
                }
            },
            "melon": {
                "socialMedia": "Melon",
                "icon": "social-media-logos/melon.png",
                "statistics": {
                    "likes": {
                        "title": "Likes",
                        "value": 23878
                    }
                }
            },
            "airplay": {
                "socialMedia": "Airplay",
                "icon": "social-media-logos/airplay.png",
                "statistics": {
                    "streams": {
                        "title": "Streams",
                        "value": 748933
                    }
                }
            },
            "tidal": {
                "socialMedia": "Tidal",
                "icon": "social-media-logos/tidal.png",
                "statistics": {
                    "popularity": {
                        "title": "Popularity",
                        "value": 87
                    }
                }
            }
        },
        "tracks": [
            {
                "id": 519,
                "album": "test 11292023-2",
                "isrc": "1",
                "title": "1",
                "imgSrc": "https:\/\/mpeapi.themusicbull.com\/Portals\/0\/Uploads\/2\/783px-Test-Logo.svg-1293431140.png",
                "releaseDate": "2023-11-02",
                "spotifyLink": null
            }
        ]
    }
]
export default TRADING_BOARD_DETAILS_DATA;